import { render } from "./BetaHome.vue?vue&type=template&id=584f31b6&scoped=true"
import script from "./BetaHome.vue?vue&type=script&lang=js"
export * from "./BetaHome.vue?vue&type=script&lang=js"

import "./BetaHome.vue?vue&type=style&index=0&id=584f31b6&scoped=true&lang=css"
import "./BetaHome.vue?vue&type=style&index=1&id=584f31b6&scoped=true&lang=css"
import "./BetaHome.vue?vue&type=style&index=2&id=584f31b6&scoped=true&lang=css"
import "./BetaHome.vue?vue&type=style&index=3&id=584f31b6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584f31b6"]])

export default __exports__